import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/travis/build/nejcm/docz-theme-extended/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import { Ref } from '@nejcm/docz-theme-extended';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "ref"
    }}>{`Ref`}</h1>
    <h3 {...{
      "id": "usage"
    }}>{`Usage`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Ref } from '@nejcm/docz-theme-extended';
`}</code></pre>
    <hr />
    <Playground __position={1} __code={'<Ref name=\"Ref to something - introduction\" to=\"/#\" />'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      Ref,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <Ref name="Ref to something - introduction" to="/#" mdxType="Ref" />
    </Playground>
    <h3 {...{
      "id": "props"
    }}>{`Props`}</h3>
    <Props table={true} of={Ref} mdxType="Props" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      